






































































import { useMachine } from "@xstate/vue";
import {
  computed,
  defineComponent,
  nextTick,
  ref,
  watch
} from "@vue/composition-api";

import { Match } from "@/types";
import { isOutOfView } from "@/utils";
import { machine } from "@/utils/textraction";
import store from "@/store/root";
import PdfForm from "@/components/PdfForm.vue";
import AuthPanel from "@/components/AuthPanel.vue";
import ModeButton from "@/components/ModeButton.vue";
import ComputedTime from "@/components/ComputedTime.vue";
import DocumentForm from "@/components/DocumentForm.vue";
import ConceptDetails from "@/components/ConceptDetails.vue";
import DocumentAnalysis from "@/components/DocumentAnalysis.vue";
import TimelineCard from "@/components/timeline/TimelineCard.vue";
import DocumentDropdown from "@/components/DocumentDropdown.vue";

export default defineComponent({
  components: {
    PdfForm,
    AuthPanel,
    ComputedTime,
    ModeButton,
    DocumentForm,
    DocumentAnalysis,
    DocumentDropdown,
    ConceptDetails,
    TimelineCard
  },
  setup() {
    const selectedType = ref<string>("1");

    const input = ref<"pdf" | "text">("text");

    const textractionMachine = useMachine(machine);

    const analyse = (value: string) => {
      Promise.resolve(value)
        .then(() => store.dispatch("updateRaw", value))
        .then(() => store.dispatch("matches/update"));
    };

    const document = computed(() => store.state.text);

    const reset = () => {
      store.dispatch("clear");
      textractionMachine.send("RESET");
    };

    const show = (value: Match) => store.dispatch("details/update", value);

    const pane = ref(null);

    const jumpTo = (match: Match) => {
      selectedType.value = match.concept.concepttype;

      nextTick(() => {
        if (pane.value !== null) {
          const container = pane.value.querySelector(
            ".vertically-scrollable"
          ) as HTMLElement;

          const element = pane.value.querySelector(
            `span[data-ids*="${match.concept.conceptid};"]`
          ) as HTMLElement;

          if (container && isOutOfView(container, element)) {
            container.scrollTop = element.offsetTop - 100;
          }
        }
      });
    };

    watch(
      () => input.value,
      () => {
        reset();
      }
    );

    return {
      selectedType,
      input,
      textractionMachine,
      document,
      pane,
      analyse,
      reset,
      show,
      jumpTo
    };
  }
});
